export default "__VITE_ASSET__CIH5H8Tb__"